<template lang="html">
    <div class="page" id="whatsInTheBag">
        <header class="pageHeader rounded">
            <fade-image class="darken" src="assets/headers/profile.png" />
        </header>

        <div class="scroller2">
            <header>
                <h2>Yardages</h2>

                <ul class="links">
                    <li>
                        <a class="cancel" @click.prevent="$router.back()" href="#">
                            <x-icon class="icon" />
                        </a>
                    </li>
                </ul>
            </header>

            <yardages-list />
        </div>
    </div>
</template>

<script>
import YardagesList from "@/components/Player/Yardages/Yardages-list";
import FadeImage from "@/components/App/fade-image";
import { XIcon } from "vue-feather-icons";
export default {
    name: "whats-in-the-bag",
    components: { YardagesList, FadeImage, XIcon },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
};
</script>

<style lang="scss"></style>
